import { Component, Input } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { TitleComponentContext } from './title-context.interface';

@Component({
    selector: 'app-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.min.css'],
})
export class TitleComponent implements BuildingBlockInterface {
    @Input() public context: TitleComponentContext;
    public paddingEnabled = true;
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/title/title.component.ts